import type { SavedOption } from '@/domain/WorkspaceForex/savedProducts/option/SavedOption.ts';
import type { FxOption, OptionBarrier } from '@/store/option/state.ts';
import { emptyOption } from '@/store/option/utils.ts';

export const mapToOption = ({ tileId, properties, type, clientId }: SavedOption): FxOption => {
  return emptyOption(
    tileId,
    type,
    {
      currencyPair: properties.currencyPair,
      legs: properties.legs.map((leg) => ({
        ...leg,
        type: leg.type === 'None' ? undefined : leg.type,
        legProductName: leg.legProductName ?? 'Vanilla',
        barrier1: restoreOptionBarrier(leg.barrier1),
        barrier2: restoreOptionBarrier(leg.barrier2),
      })),
      premiumPaymentDateTenor: properties.premiumPaymentDateTenor,
      settlementType: properties.settlementType,
      cutOffMarketPlace: properties.cutOffMarketPlace,
      premiumType: properties.premiumType,
      hedgeType: properties.hedgeType,
      hedges: properties.hedges,
      uiState: properties.uiState,
    },
    clientId,
  );
};

function restoreOptionBarrier(
  barrier: SavedOption['properties']['legs'][number]['barrier1'],
): OptionBarrier | undefined {
  if (barrier === undefined) {
    return undefined;
  }

  return {
    ...barrier,
    level: barrier.level ?? undefined,
    startDate: barrier.startDate ?? undefined,
    endDate: barrier.endDate ?? undefined,
  };
}
